import { UseFormReturn } from 'react-hook-form';
import { FormController } from './form-controller';
import { FormGroup } from './form-groups';

export const useFormController = <T extends Record<string, any>>(
  methods: UseFormReturn<{ groups: FormGroup<T>[] }>
): FormController<T> => {
  return {
    control: methods.control,
  };
};
